import React, { useCallback } from 'react';
import * as icons from '~/ui/assets/icons';
import getInitials from '~/common/getInitials';
import { Hamburguer as HamburgerIcon } from '~/ui/assets/icons';
import { useDrawer } from '~/hooks/useDrawer';
import BackofficeLogo from '../../assets/imgs/backoffice.svg';
import LogoSmall from '../../assets/imgs/logoSmall.svg';

import { Hamburguer } from './Hamburguer/Hamburguer';

import { Settings } from './Settings/Settings';
import { ThemeToggle } from './ThemeToggle';
// import { Notification } from './Notification/Notification';
import { SessionTimer } from './SessionTimer/SessionTimer';

import {
  Navbar,
  NavbarLogo,
  NavbarMenu,
  NavbarButton,
  NavbarItem,
  Caret,
  Submenu,
  SubItem,
  SubmenuWrapper,
  ButtonLine,
  ProfilePicture,
  RightNavbar,
  HamburguerMenu,
} from './Menu.styled';

type IconsTypes = keyof typeof icons;

export interface MenuItem {
  title: string;
  icon?: IconsTypes;
  items?: MenuItem[];
  path?: string;
}

interface MenuProps {
  items: MenuItem[];
  profileName?: string;
  /** conteúdo extra à direita do header (ex.: status de disponibilidade no atendimento) */
  rightExtra?: React.ReactNode;
}

export function Menu({ items, profileName, rightExtra }: Readonly<MenuProps>) {
  const { openDrawer } = useDrawer();
  const getIcon = useCallback((icon: IconsTypes) => {
    const Icon = icons[icon];

    return <Icon />;
  }, []);

  const handleNavbarClick = (item) => (e) => {
    if (!item.path) {
      e.preventDefault();
    }
  };

  const handleOpenMenuDrawer = () => {
    openDrawer('menu-drawer', <Hamburguer items={items} />, {
      title: undefined,
      backButton: false,
      placement: 'left',
      width: 320,
      closable: false,
      maskClosable: true,
      noPadding: true,
      className: 'menu-drawer',
    });
  };

  return (
    <Navbar>
      <NavbarLogo>
        <BackofficeLogo />
        <LogoSmall className="mobile" />
      </NavbarLogo>

      <NavbarMenu>
        <HamburguerMenu onClick={handleOpenMenuDrawer}>
          <HamburgerIcon className="action-icon" width={13} height={13} />
        </HamburguerMenu>
        {items?.map((item) => (
          <React.Fragment key={item.title}>
            <NavbarItem>
              <NavbarButton to={item.path || '/'} onClick={handleNavbarClick(item)}>
                <>
                  {getIcon(item.icon)}
                  {item.title}
                  <ButtonLine className="bottom-line" />
                </>
              </NavbarButton>

              {item?.items?.length && (
                <>
                  {item?.items?.length && <Caret className="caret" />}
                  <SubmenuWrapper className="submenu">
                    <Submenu>
                      {item?.items.map((subItem) => (
                        <React.Fragment key={subItem.title}>
                          <SubItem to={subItem.path || '/'}>
                            {getIcon(subItem.icon)}

                            {subItem.title}
                          </SubItem>
                        </React.Fragment>
                      ))}
                    </Submenu>
                  </SubmenuWrapper>
                </>
              )}
            </NavbarItem>
          </React.Fragment>
        ))}
      </NavbarMenu>

      <RightNavbar>
        {rightExtra}
        <SessionTimer />
        {/* <Notification trigger="click" /> */}
        <ThemeToggle />
        <Settings trigger="click" />
        <ProfilePicture content={profileName || '-'}>{getInitials(profileName) || '-'}</ProfilePicture>
      </RightNavbar>
    </Navbar>
  );
}
